/**
 * 20 preset queue icons + helpers used by the queue settings panel and
 * the public display cards.
 *
 * Each preset is keyed by a short lowercase identifier — that key is stored
 * on the queue document (`queue.icon`) and resolved at render time to the
 * matching lucide-react component. The merchant can also upload a custom
 * image (PNG/JPG/SVG) ; in that case the icon field stores a `data:` URL
 * that we render with `<img />` directly (helper `isCustomIcon`).
 */
import {
  UserRound,
  Stethoscope,
  HeartPulse,
  ClipboardList,
  Banknote,
  Car,
  Wrench,
  FileText,
  Phone,
  Ticket,
  ShieldCheck,
  Utensils,
  Truck,
  Headphones,
  LifeBuoy,
  Briefcase,
  GraduationCap,
  ShoppingCart,
  Package,
  Building2,
} from "lucide-react";

export const QUEUE_ICON_PRESETS = [
  { key: "accueil", label: "Accueil", Icon: UserRound },
  { key: "medical", label: "Médical", Icon: Stethoscope },
  { key: "urgence", label: "Urgence", Icon: HeartPulse },
  { key: "consultation", label: "Consultation", Icon: ClipboardList },
  { key: "caisse", label: "Caisse", Icon: Banknote },
  { key: "vehicule", label: "Véhicule", Icon: Car },
  { key: "technique", label: "Technique", Icon: Wrench },
  { key: "document", label: "Document", Icon: FileText },
  { key: "telephone", label: "Téléphone", Icon: Phone },
  { key: "ticket", label: "Ticket", Icon: Ticket },
  { key: "securite", label: "Sécurité", Icon: ShieldCheck },
  { key: "restaurant", label: "Restaurant", Icon: Utensils },
  { key: "livraison", label: "Livraison", Icon: Truck },
  { key: "assistance", label: "Assistance", Icon: Headphones },
  { key: "sav", label: "SAV", Icon: LifeBuoy },
  { key: "administration", label: "Administration", Icon: Briefcase },
  { key: "education", label: "Éducation", Icon: GraduationCap },
  { key: "vente", label: "Vente", Icon: ShoppingCart },
  { key: "colis", label: "Colis", Icon: Package },
  { key: "mairie", label: "Mairie", Icon: Building2 },
];

const PRESET_MAP = QUEUE_ICON_PRESETS.reduce((acc, p) => {
  acc[p.key] = p.Icon;
  return acc;
}, {});

export function isCustomIcon(value) {
  return typeof value === "string" && value.startsWith("data:");
}

/**
 * Return a React component to render the preset icon, or null when the
 * icon value is empty / unknown / a custom data URL (custom icons must
 * be rendered with <img src={icon} />).
 */
export function getQueueIcon(value) {
  if (!value || isCustomIcon(value)) return null;
  return PRESET_MAP[value] || null;
}

export function getIconKey(value) {
  if (!value || isCustomIcon(value)) return null;
  return PRESET_MAP[value] ? value : null;
}
